import { render } from "./grant_funding_compliance.html?vue&type=template&id=b8854606&external"
import script from "./grant_funding_compliance.js?vue&type=script&lang=js&external"
export * from "./grant_funding_compliance.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__